import {callsApi, apiV2} from 'sources/api';
import {Set} from 'immutable';

export class FileUploadSource {
  static findFilesById(ids) {
    const fields = {
      Id: {
        values: Set(ids),
        type: 'some_of',
      },
    };
    const body = {
      fields,
      sort_by_date: true,
    };
    return callsApi.post('/search/id_only', body);
  }

  static getFileInfo(id) {
    return apiV2.get(`/library/file/${id}/` /* <-- This trailing slash matters!! thanks python */);
  }
}
